import { pickBy } from 'lodash-es';

export const reducePartialRequest = (queries: object) => pickBy(queries, q => q !== undefined);
